import { render, staticRenderFns } from "./TicketPricePreview.vue?vue&type=template&id=1e7bb0b4"
import script from "./TicketPricePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketPricePreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TicketPricePreview.vue?vue&type=style&index=0&id=1e7bb0b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports